/**
 * backend.js
 *
 * Talks to PersonalBackend (Flask on AWS), which owns the SQL database.
 * Every request carries the signed-in user's Firebase ID token, which the backend checks.
 */

import { auth } from "./firebase";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.isayyashtothat.com";

/**
 * A failed backend request, with its HTTP status (e.g. 404, 409)
 */
export class BackendError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

/**
 * Calls the backend and returns its JSON
 * @param {String} path         -   e.g. '/auction/libraries/k7mq2x'
 * @param {Object} options      -   { method, body, headers (extra), withCookies (send the backend's cookies, e.g. Flight YJ030 check-in) }
 * @returns {Object}            -   Response JSON
 */
export const callBackend = async (path, { method = "GET", body, headers: extraHeaders, withCookies = false } = {}) => {
    const headers = { ...extraHeaders };
    const token = await auth.currentUser?.getIdToken();
    if (token) headers.Authorization = `Bearer ${token}`;
    if (body !== undefined) headers["Content-Type"] = "application/json";

    const response = await fetch(`${BACKEND_URL}${path}`, {
        method,
        headers,
        body        :   body === undefined ? undefined : JSON.stringify(body),
        credentials :   withCookies ? "include" : "same-origin",
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new BackendError(data.error || `Request failed (${response.status})`, response.status);
    return data;
};
